import React from "react";
import ReportDataTable from "./ReportDataTable";
import { createVoidKotReportRows } from "../utils/csvExport";

const columns = [
  { label: "S/N", key: "serial", render: (row) => row.serial },
  { label: "Order Date", key: "orderDate" },
  { label: "Order Id", key: "orderId" },
  { label: "KOT Id", key: "kot_id" },
  { label: "Item Name", key: "menu_item_name" },
  { label: "Qty", key: "quantity" },
  { label: "Price(Rs.)", key: "price", render: (row) => Number(row.price || 0).toFixed(2) },
  { label: "Cancelled By", key: "cancelled_by" },
  { label: "Reason", key: "cancellation_reason" },
];

const VoidKotReport = ({ rows = [], loading }) => {
  const voidRows = createVoidKotReportRows(rows);

  return (
    <ReportDataTable
      columns={columns}
      rows={voidRows.map((row, index) => ({ ...row, serial: index + 1 }))}
      loading={loading}
      emptyMessage="No void KOT report data found."
    />
  );
};

export default VoidKotReport;
